import { initContract } from '@ts-rest/core';
import { contactenContract } from './contactenContract';
import { verrichtingenContract } from './verrichtingen.contract';

export const contract = initContract();

export const mijnKsyosContract = contract.router({
    contacten: contactenContract,
    verrichtingen: verrichtingenContract,
});

export type MijnKsyosContract = typeof mijnKsyosContract;
